// extracted by mini-css-extract-plugin
export default {"value":"MicropileParametersSection_value__rdIeg","wrapper":"MicropileParametersSection_wrapper__9ZOPQ"};